// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-container {
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.login-form {
  width: 300px;
  display: flex;
  flex-direction: column;
}

.login-form input {
  padding: 10px;
  margin-bottom: 10px;
}

.login-form button {
  padding: 10px;
  background: #2563eb;
  color: white;
  border: none;
  cursor: pointer;
}

.login-form button:hover {
  background: #1e40af;
}

.login-error {
  color: #dc2626;
  margin-bottom: 10px;
  text-align: center;
}

.login-toggle {
  margin-top: 15px;
  text-align: center;
  color: #666;
}

.login-toggle button {
  background: none;
  border: none;
  color: #2563eb;
  cursor: pointer;
  text-decoration: underline;
  font-size: inherit;
}

.login-toggle button:hover {
  color: #1e40af;
}
`, "",{"version":3,"sources":["webpack://./src/Login.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB","sourcesContent":[".login-container {\n  height: 100vh;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n.login-form {\n  width: 300px;\n  display: flex;\n  flex-direction: column;\n}\n\n.login-form input {\n  padding: 10px;\n  margin-bottom: 10px;\n}\n\n.login-form button {\n  padding: 10px;\n  background: #2563eb;\n  color: white;\n  border: none;\n  cursor: pointer;\n}\n\n.login-form button:hover {\n  background: #1e40af;\n}\n\n.login-error {\n  color: #dc2626;\n  margin-bottom: 10px;\n  text-align: center;\n}\n\n.login-toggle {\n  margin-top: 15px;\n  text-align: center;\n  color: #666;\n}\n\n.login-toggle button {\n  background: none;\n  border: none;\n  color: #2563eb;\n  cursor: pointer;\n  text-decoration: underline;\n  font-size: inherit;\n}\n\n.login-toggle button:hover {\n  color: #1e40af;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
